import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import type { P2PRecentRecipient } from "../api";

interface Props {
  recipient: P2PRecentRecipient;
  onSelect: (recipient: P2PRecentRecipient) => void;
}

export default function RecentRecipientCard({ recipient, onSelect }: Props) {
  const initial =
    (recipient.username ?? recipient.full_name ?? "?")
      .charAt(0)
      .toUpperCase();

  return (
    <VibratingButton
      onClick={() => onSelect(recipient)}
      className="shrink-0 flex flex-col items-center gap-1.5 w-16 active:opacity-70 transition-opacity"
      aria-label={recipient.username ? `@${recipient.username}` : recipient.full_name ?? ""}
    >
      <div className="size-14 rounded-full overflow-hidden border border-white/10  bg-orange-100/15 flex-center">
        {recipient.avatar_url ? (
          <img
            src={recipient.avatar_url}
            alt={recipient.username ?? ""}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <span className="text-orange-100 text-lg font-semibold">{initial}</span>
        )}
      </div>
      <span className="text-[11px] leading-none text-white truncate w-full text-center">
        @{recipient.username ?? "—"}
      </span>
    </VibratingButton>
  );
}
